import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  key: 0,
  class: "form-control form-control-lg form-control-solid mb-3"
}
const _hoisted_4 = { class: "d-flex justify-content-between mb-2 w-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "fw-normal" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Seleccione una persona")
], -1)
const _hoisted_6 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fw-normal" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Función que desempeña")
], -1)
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_11 = { class: "fw-normal" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger me-1" }, "*", -1)
const _hoisted_13 = { class: "col-sm-6" }
const _hoisted_14 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_15 = { class: "fw-normal" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger me-1" }, "*", -1)
const _hoisted_17 = { class: "form-group row" }
const _hoisted_18 = { class: "col-sm-8" }
const _hoisted_19 = { class: "col-sm-4" }
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "col-sm-6" }
const _hoisted_23 = { class: "form-group row" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_add_edit_function = _resolveComponent("add-edit-function")!
  const _component_AddEditPerson = _resolveComponent("AddEditPerson")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "bg-light rounded",
    onOpen: _ctx.onOpen,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    draggable: "",
    "destroy-on-close": "",
    top: "2vh"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_el_button, {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isModalVisible = false)),
          text: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancelar")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: _ctx.loading,
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.itemUser ? _ctx.t('update') : _ctx.t('save')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_form, {
            ref: "ruleFormRef",
            model: _ctx.form,
            "status-icon": "",
            rules: _ctx.rules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              (_ctx.itemUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.form?.firstname + ' ' + _ctx.form?.lastname + ' ' + _ctx.form?.surname), 1))
                : (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    prop: "idperson",
                    rules: [{ required: true, message: 'Campo requerido', trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createVNode(_component_el_button, {
                          type: "primary",
                          link: "",
                          onClick: _ctx.openAddPerson
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('add')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.idperson,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.idperson) = $event)),
                        "value-key": "idperson",
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        placeholder: "Ingrese un texto a buscar...",
                        "remote-method": _ctx.remoteMethod,
                        loading: _ctx.loading,
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPeople, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.idperson,
                              label: item.people,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "remote-method", "loading"])
                    ]),
                    _: 1
                  })),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  onClick: _ctx.openAddFunction
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('add')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_el_form_item, {
                prop: "idfunction",
                rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.idfunction,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.idfunction) = $event)),
                    filterable: "",
                    clearable: "",
                    placeholder: _ctx.t('seleccione'),
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFunctions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `lr-${item.idfunction}`,
                          label: item.name,
                          value: item.idfunction
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, [
                      _hoisted_12,
                      _createTextVNode(_toDisplayString(_ctx.t('username')), 1)
                    ]),
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: "Generar automaticamente",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "bi bi-magic text-info fs-1 cursor-pointer text-hover-primary",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.generateUsername && _ctx.generateUsername(...args)))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_form_item, {
                    prop: "username",
                    rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.username,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.username) = $event)),
                        modelModifiers: { trim: true }
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, [
                      _hoisted_16,
                      _createTextVNode(_toDisplayString(_ctx.t('password')), 1)
                    ]),
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: "Generar automaticamente",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: "bi bi-magic text-info fs-1 cursor-pointer text-hover-primary",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.generatePassword && _ctx.generatePassword(...args)))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_form_item, {
                    prop: "password",
                    rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.password,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.password) = $event)),
                        modelModifiers: { trim: true },
                        type: "password",
                        "show-password": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_el_form_item, {
                    prop: "email",
                    label: "Email de recuperación",
                    rules: [{ type: 'email', message: 'Email inválido', trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.email,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email) = $event)),
                        modelModifiers: { trim: true }
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_el_form_item, {
                    prop: "date_end",
                    label: "Fecha de caducidad"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.date_end,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.date_end) = $event)),
                        type: "date",
                        placeholder: _ctx.t('seleccione'),
                        format: "DD/MM/YYYY",
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_el_form_item, {
                    prop: "idperfil",
                    label: _ctx.t('profile'),
                    rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.idperfil,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.idperfil) = $event)),
                        placeholder: _ctx.t('seleccione'),
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listProfiles, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: `ae-u-${item.idperfil}`,
                              label: item.name,
                              value: item.idperfil
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_el_form_item, { label: "Notificar por correo electrónico" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.form.delivery,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.delivery) = $event)),
                        "active-text": "Si",
                        "inactive-text": "No"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_el_form_item, { label: "Alcance de visualización" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.form.accessview,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.accessview) = $event)),
                        "active-text": "Todos",
                        "inactive-text": "Propios",
                        "active-value": "1",
                        "inactive-value": "0"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.itemUser)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        prop: "accstatus",
                        label: _ctx.t('state')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.accstatus,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.accstatus) = $event)),
                            placeholder: "Seleccione",
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: `ae-u-${item.id}`,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ]),
      _createVNode(_component_add_edit_function, {
        ref: "AddEditFunctionRef",
        onOnResponseAddEditFunction: _ctx.onResponseFunction
      }, null, 8, ["onOnResponseAddEditFunction"]),
      _createVNode(_component_AddEditPerson, { ref: "AddEditPersonRef" }, null, 512)
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onClosed"]))
}